module.exports = __webpack_public_path__ + "static/media/ipad-instruction.dacbe6de.mp4";